import queryString from 'query-string';
import banquet from "./img/banquet.png";
import boardroom from "./img/boardroom.png";
import classroom from "./img/classroom.png";
import reception from "./img/reception.png";
import theatre from "./img/theatre.png";
import ushape from "./img/u-shape.png";
import User from "./components/LogIn/User";
import accomdationIcon from "./img/icons/ico-accomdation.svg";
import accessibilityIcon from "./img/icons/ico-accessibility.svg";
import barIcon from "./img/icons/ico-bar.svg";
import conciergeIcon from "./img/icons/ico-concierge.svg";
import resturantsIcon from "./img/icons/ico-resturants.svg";
import coffeeIcon from "./img/icons/ico-coffee.svg";
import pantryIcon from "./img/icons/ico-coffee.svg";
import groceryIcon from "./img/icons/ico-grocery.svg";
import gymIcon from "./img/icons/ico-gym.svg";
import parkingIcon from "./img/icons/ico-free-parking.svg";
import prayerroomIcon from "./img/icons/ico-prayer-room.svg";
import wastedisposalIcon from "./img/icons/ico-waste-disposal.svg";
import wifiIcon from "./img/icons/ico-wifi.svg";
import flipchartIcon from "./img/icons/ico-flipchart.svg";
import whiteboardIcon from "./img/icons/ico-whiteboard.svg";
import lcdIcon from "./img/icons/ico-lcd-screens.svg";
import micIcon from "./img/icons/ico-mic.svg";
import avIcon from "./img/icons/ico-av.svg";
import videoConfIcon from "./img/icons/ico-video-conf.svg";
import projectorIcon from "./img/icons/Projector&Screen.svg";
import wifiSharedIcon from "./img/icons/ico-wifi-shared.svg";
import furniturePriIcon from "./img/icons/ico-furniture.svg";
import telPriIcon from "./img/icons/ico-telephone-line.svg";
import elecSharedIcon from "./img/icons/ico-electricity.svg";
import receptionIcon from "./img/icons/ico-receptionist.svg";
import mailIcon from "./img/icons/ico-mail-management.svg";
import printerIcon from "./img/icons/ico-printer.svg";
import statIcon from "./img/icons/ico-stat.svg";
import lecturnIcon from "./img/icons/ico-lecturn.svg";
import {CitiesRef} from "./citiesRef";
import React from "react";
import moment from "moment";
import axios from "axios";
import ReactGA from "react-ga-neo";
import Bugsnag from "@bugsnag/js";
import libphonenumber from "google-libphonenumber";
import {ReservStyles} from "./styles/ReservStyles";


let phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
let PNF = libphonenumber.PhoneNumberFormat

var currencyList = [];

export function fixBookingError() {
  if (getStorage().getItem('bookingError') !== 'fixed') {
    resetProposalBooking();
    resetSpaceBooking();
    getStorage().setItem('bookingError', 'fixed');
  }
}

function getOverride() {
  return getStorage().getItem('override')
}

export function isLocal() {
  let override = getOverride();
  if (Boolean(override)) {
    return (override === 'local')
  } else {
    return (window.location.hostname === 'localhost')
  }
}

export function isDev() {
  let override = getOverride();
  if (Boolean(override)) {
    return (override === 'dev')
  } else {
    return (window.location.hostname === 'dev.fluidmeet.com')
  }
}

export function isLive() {
  return !(isLocal() || isDev())
}

function getLogControl() {
  return getStorage().getItem('logControl')
}

export function allowLogs() {
  let logControl = getLogControl();
  switch (logControl) {
    case 'force-no':
      return false;
    case 'force-yes':
      return true;
    default:
      return (!isLive());
  }
  
  
}

export function devLog(...args) {
  if (allowLogs()) {
    console.log(...args)
  }
}

export function getApiLinkV2(link) {
  return getApiLink('v2/'+link)
}
export function getApiLink(link) {
  // devLog({isLocal:isLocal(),isDev:isDev(),isLive:isLive(),override:getOverride()})
  let apiUrl;
  if (isLocal()) {
    apiUrl = 'http://fluidmeet.local/api/'
  } else if (isDev()) {
    apiUrl = 'https://host-dev.fluidmeet.com/api/'
  } else {
    apiUrl = 'https://host.fluidmeet.com/api/';
  }
  
  return apiUrl + link;
}
export function getAxios() {
  
  if (isLocal() || isDev()) {
    return axios.create();
  } else {
    return axios.create()
  }
  
}

export function getBucket() {
  if (isLocal() || isDev()) {
    return 'fluidmeet-dev'
  } else {
    return 'fluidmeet';
  }
  
}

export function getImageUrl(image_name, suffix) {
  const bucket = getBucket();
  let final_name = image_name;
  if (suffix) {
    let filename_array = final_name.split('.')
    let fileExt = filename_array.pop();
    final_name = filename_array.join() + suffix;
  }
  return `https://${bucket}.s3.amazonaws.com/venue_logos/${final_name}`
}

export function getStripePublishableKey() {
  if (isDev() || isLocal())
    return "pk_test_51K3ZfeH5HyswfcUnoOqQEpBVgr8kL48sjxa8FDO5w667YVRrF4pVWw0VPORNtXIhjzsG8KuE0g9txXQ37fTEEdi000dgz174bb";
  else
    return "pk_live_51K3ZfeH5HyswfcUnpzKFuZF0OXs5RTZsqePf0grkn2R3YFrUkVOTaDAIqAILatzmK6yUFsuDqIzSz3Mz7ePjYP0x00eP79aRgR";
}

export default function printLocal(key) {

  switch (key) {
    case 'business-setup':
      return 'Business Setup';
    case 'serviced-offices':
      return 'Serviced Offices';  
    case 'office-spaces':
    case 9:
      return 'Office Spaces';
    case 'banquets-and-event-spaces':
    case 10:
      return 'Banquet & Event Halls';
    case 'co-working-spaces':
    case 4:
      return 'Co-working Spaces';
    case 'meeting-rooms':
    case 5:
      return 'Meeting Rooms';
    case 30:
      return 'Business Setup';
    case 'dubai':
      return 'Dubai';
    case 'abu-dhabi':
    case 'Abu-Dhabi':
      return 'Abu Dhabi';
    case 'sharjah':
      return 'Sharjah';
    case 'Al-Jubail':
      return 'Al Jubail';
    case 'Masqat-Matrah':
      return 'Masqat Matrah';
    case 'doha':
    case 'Doha-and-the-rest-of-Qatar':
      return 'Doha Qatar';
    case 'manama-and-the-rest-of-bahrain':
    case 'Manama-and-the-rest-of-Bahrain':
      return 'Manama & The Rest Of Bahrain';
    case 'Kuwait':
    case 'Kuwait-City':
      return 'Kuwait';
    case 'london':
      return 'London';
    case 'mumbai':
      return 'Mumbai';
    case 'bangalore':
      return 'Bangalore';
    case 'riyadh':
      return 'Riyadh';
    case 'rating':
      return 'Highest Rating';
    case 'newest':
      return 'Newest Added';
    case 'nearby':
      return 'Nearby';
    case 'hour':
      return 'Hour';
    case 'half_day':
      return 'Half day';
    case 'day':
      return 'Day';
    case 'annually':
      return 'Price Annually';
    case 'person':
      return 'Per Person';
    case 'cap':
      return 'Price Cap';
    case 'details':
      return 'Details';
    case 'amenity':
      return 'Amenities';
    case 'facilities':
      return 'Facilities';
    case 'reviews':
      return 'Reviews';
    case 'share':
      return 'Share';
    case 'allprices':
      return 'All Prices';
    default:
      return key.toString().split(/[\s,\-_]+/).map(
          (text) => {
            return (text.charAt(0).toUpperCase()) + text.substring(1);
          }
      ).join(' ');
  }
}

export function printTypeLink(key) {

  switch (key) {
    case 9:
      return 'office-spaces';
    case 10:
      return 'banquets-and-event-spaces';
    case 4:
      return 'co-working-spaces';
    case 5:
      return 'meeting-rooms';
    default:
      return key;
  }
}

export function printCountry(key) {
  return (key && CitiesRef[printLocal(key)]) ? CitiesRef[printLocal(key)] : 'United States';
}

export function getImage(name) {

  switch (name) {
    case 'banquet':
      return banquet;
    case 'boardroom':
      return boardroom;
    case 'classroom':
      return classroom;
    case 'reception':
      return reception;
    case 'theatre':
      return theatre;
    case 'ushape':
      return ushape;
    default:
      return ushape;
  }
}

export function printMonth(num) {

  switch (num) {
    case 'One month':
      return '1 month';
    case 'Two month':
      return '2 month';
    case 'Three month':
      return '3 month';
    case 'Four month':
      return '4 month';
    case 'Five month':
      return '5 month';
    case 'Six month':
      return '6 month';
    case 'Seven month':
      return '7 month';
    case 'Eight month':
      return '8 month';
    case 'Nine month':
      return '9 month';
    case 'Ten month':
      return '10 month';
    default:
      return '0 month';
  }
}

export function printLink(pathname, search, key, value, removePage = false) {

  let queryObj = queryString.parse(search);
  // queryObj[key] = JSON.stringify(value).replace(/['"]+/g, '');
  queryObj[key] = value;
  if (removePage) {
    delete queryObj['p'];
  }
  let queryStr = queryString.stringify(queryObj);
  return pathname+"?"+queryStr;
}

export function printLinks(pathname, search, dict, removePage = false) {

  let queryObj = queryString.parse(search);
  Object.keys(dict).forEach(key => {
    let value = dict[key];
    if (value instanceof Object) {
      if (Object.keys(value).length > 0) {
        queryObj[key] = Object.keys(value);
      } else {
        delete queryObj[key];
      }
    } else if (value !== "" || value > 0) {
      queryObj[key] = value;
    } else {
      delete queryObj[key];
    }
  });
  if (removePage) {
    delete queryObj['p'];
  }
  let queryStr = queryString.stringify(queryObj);
  return pathname+"?"+queryStr;
}

export function printLinkRemoved(pathname, search, key) {

  let queryObj = queryString.parse(search);
  if (key === "price") {
    delete queryObj.m_pr;
    delete queryObj.min_pr;
    delete queryObj.max_pr;
    delete queryObj.pr_t;
  } else {
    delete queryObj[key];
  }
  let queryStr = queryString.stringify(queryObj);
  return pathname+"?"+queryStr;
}

export function isSpaceOld(dateAdded) {
  const dateParts = dateAdded.match(/(\d+)-(\d+)-(\d+) (\d+):(\d+):(\d+)/);
  const dataTime = new Date(parseInt(dateParts[3]) + "-" + parseInt(dateParts[2]) + "-" + parseInt(dateParts[1]) + " " + parseInt(dateParts[4])+ ":" + parseInt(dateParts[5]) + ":" + parseInt(dateParts[6])).getTime();
  return (((new Date().getTime()/1000) - 2628288) > dataTime);
}

export function printFilterKey(filter) {

  switch (filter) {
    case 'z':
      return 'licence_zone';
    case 'ls_t':
      return 'license_type';
    case 'ls_a':
      return 'license_authority';
    case 'n':
      return 'neighborhood';
    case 't':
      return 'term';
    case 's':
      return 'sort';
    case 'v_t':
      return 'venue_type';
    case 'o_t':
      return 'office_type';
    case 'c':
      return 'capacity';
    case 'a':
      return 'amenity';
    case 'pr':
      return 'price';
    case 'v':
      return 'venue';
    case 'l':
      return 'layout';
    case 'ls':
      return 'layouts';
    case 'av':
      return 'availability';
    case 's_f':
      return 'suitable_for';
    case 'l_z':
      return 'licensing_zone';
    case 'min_pr':
    case 'max_pr':
      return 'price';
    case 'pr_t':
      return 'price-type';
    case 'pr_r':
      return 'price-range';
    case 'm_pr':
      return 'max_price';
    case 's_s':
      return 'sort-search';
    case 'x':
      return 'x';
    case 'y':
      return 'y';
    case 'term':
      return 't';
    case 'sort':
      return 's';
    case 'licence_zone':
      return 'z';
    case 'license_type':
      return 'ls_t';
    case 'license_authority':
      return 'ls_a';
    default:
      return filter;
  }
}


export function printNeighbor(name) {

  const fName = name.replace(/-/g,' ');

  switch (fName) {
    case 'Al Barsha/TECOM':
      return '1';
    case 'Al Fahidi/Bur Dubai':
      return '3';
    case 'Al Mamzar':
      return '9';
    case 'Al Quoz':
      return '13';
    case 'Al Twar':
      return '12';
    case 'Deira/Al Qusais/Al Garhoud':
      return '17';
    case 'DIFC/Sheikh Zayed Road/Trade Center':
      return '18';
    case 'Downtown Dubai/Business Bay':
      return '19';
    case 'Dubai Marina & JBR':
      return '20';
    case 'Dubai Media, Internet City & Knowledge Village':
      return '21';
    case 'Dubai Silicon Oasis':
      return '24';
    case 'Dubailand (Motor city, Arabian Ranches, Studio City)':
      return '42';
    case 'Investment Park':
      return '26';
    case 'Jebel Ali':
      return '28';
    case 'JLT':
      return '29';
    case 'Oud Metha':
      return '33';
    default:
      return fName;
  }
}

export function pathName(path) {
    return path;
    // return path.slice(0, path.lastIndexOf('/'));
}

export function getStorage() {
  return (window.localStorage || window.sessionStorage);
}

export function setCurrency(currency) {
  getStorage().setItem('currency', currency);
  window.dispatchEvent(new Event('storage'))
}

export function setUser(userData, userToken) {
  getStorage().setItem('user', JSON.stringify(userData));
  getStorage().setItem('token', JSON.stringify(userToken));
}
export function setHostStatus(status) {
  const user = JSON.parse(getStorage().getItem('user'));

  user.status = status;
  if (user == null || typeof user == 'undefined') return;
  getStorage().setItem('user', JSON.stringify(user));
 
}

export function setAskedLocaiton() {
  getStorage().setItem('location', true);
}

export function setUserData(userData) {
  const user = JSON.parse(getStorage().getItem('user'));
  user.first_name = userData.first_name;
  user.last_name = userData.last_name;
  user.phone = userData.phone;
  user.email = userData.email;
  user.country = userData.country;
  user.city = userData.city;
  user.company = userData.company;
  user.position = userData.position;
  getStorage().setItem('user', JSON.stringify(user));
}

export function setUserImage(userImage) {
  const userData = JSON.parse(getStorage().getItem('user'));
  userData.image = userImage;
  getStorage().setItem('user', JSON.stringify(userData));
}

export function setUserName(firstName, lastName) {
  const userData = JSON.parse(getStorage().getItem('user'));
  userData.first_name = firstName;
  userData.last_name = lastName;
  getStorage().setItem('user', JSON.stringify(userData));
}

export function setUserPhone(userPhone) {
  const userData = JSON.parse(getStorage().getItem('user'));
  userData.phone = userPhone;
  getStorage().setItem('user', JSON.stringify(userData));
}

export function setSource(source) {
  getStorage().setItem('source', source);
}

export function setSpaceBooking(space) {
  getStorage().setItem('booking_space', JSON.stringify(space));
}

export function setProposalBooking(request) {
  getStorage().setItem('booking_proposal', JSON.stringify(request));
}

export function setCurrencies(currencies) {
  getStorage().setItem('currencies', JSON.stringify(currencies));
}

export function setVatPercentage(vatPercentages) {
  getStorage().setItem('vat_percentages', JSON.stringify(vatPercentages));
}

export function resetCurrency() {
  getStorage().removeItem('currency');
}

export function resetCurrencies() {
  getStorage().removeItem('currencies');
}

export function resetUser() {
  getStorage().removeItem('user');
  getStorage().removeItem('token');
}

export function resetSpaceBooking() {
  getStorage().removeItem('booking_space');
}

export function resetBookings() {
  try {
    resetSpaceBooking();
    resetProposalBooking();
  } catch (error) {
    Bugsnag.notify(error);
    devLog(error);
  }
}

export function resetProposalBooking() {
  getStorage().removeItem('booking_proposal');
}

export function getCurrencies() {

  const defCurrenciesList = [
    { name: 'USD', icon: '$', exchange_rate: 1, country: 'United States' },
    { name: 'AED', icon: 'AED', exchange_rate: 3.67, country: 'United Arab Emirates' },
    { name: 'GBP', icon: '£', exchange_rate: 0.72, country: 'United Kingdom' },
    { name: 'SAR', icon: 'ر.س', exchange_rate: 3.75, country: 'Saudi Arabia' },
    { name: 'QAR', icon: 'ر.ق', exchange_rate: 3.64, country: 'Qatar' },
    { name: 'KWD', icon: 'د.ك', exchange_rate: 0.30, country: 'Kuwait' },
    { name: 'BHD', icon: 'د.ب', exchange_rate: 0.38, country: 'Bahrain' },
    { name: 'JOD', icon: 'د.أ', exchange_rate: 0.71, country: 'Jordan' },
    { name: 'OMR', icon: 'ر.ع', exchange_rate: 0.39, country: 'Oman' },
    { name: 'INR', icon: '₹', exchange_rate: 72.92, country: 'India' }];

  const currencies = getStorage().getItem('currencies');
  const currencyList = currencies ? JSON.parse(currencies) : null;
  if (currencyList && Object.keys(currencyList).length > 0) {
    const defCurr = currencyList.find(x => x.name === 'USD');
    return (defCurr && defCurr.country) ? currencyList : defCurrenciesList;
  }
  return defCurrenciesList;
}

export function getVatPercentages(country = null) {
  let allVatPercentages = getStorage().getItem('vat_percentages');
  if (country) {
    allVatPercentages = JSON.parse(allVatPercentages);
    let vatCountry = allVatPercentages.filter(vat => {
      return vat.country === country
    });
    return vatCountry.length >= 1 ? vatCountry[0].vat_percent : 5;
  }

  return allVatPercentages;
}

export function getPaymentCurrencies() {
  return [
    { name: 'USD', icon: '$', exchange_rate: 1 },
    { name: 'AED', icon: 'AED', exchange_rate: 3.67, country: 'United Arab Emirates' }
  ];
}

export function getOldCurrency() {
  const curr = getStorage().getItem('currency');
  return curr ? curr : null;
}

export function getCurrency(def) {
  const curr = getStorage().getItem('currency');
  const currencyList = getCurrencies();
  const defCurrency = (def && currencyList.find(x => x.name === def)) ? currencyList.find(x => x.name === def) : currencyList.find(x => x.name === 'USD');
  return (curr && currencyList.find(x => x.name === curr)) ? currencyList.find(x => x.name === curr) : defCurrency;
}



export function finalPrice(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function printPriceOnly(amount, from, to, round = false) {
  const price = convert(parseFloat(amount), from, to);
  return round ? (Math.round(price)) : (Math.round((price + Number.EPSILON) * 100) / 100);
}

export function printPricePretty(amount, from, to, round = false) {
  var price = convert(parseFloat(amount), from, to);
  price = round ? (Math.round(price)) : (Math.round((price + Number.EPSILON) * 100) / 100);
  return finalPrice(price);
}

export function printPrice(amount, from, to, round = false) {

  if (to === 'USD') { return '$' + printPricePretty(amount, from, to, round); }
  if (to === 'GBP') { return '£' + printPricePretty(amount, from, to, round); }
  if (to === 'AED') { return 'AED ' + printPricePretty(amount, from, to, round); }
  if (to === 'SAR') { return 'ر.س ' + printPricePretty(amount, from, to, round); }
  if (to === 'QAR') { return 'ر.ق ' + printPricePretty(amount, from, to, round); }
  if (to === 'KWD') { return 'د.ك ' + printPricePretty(amount, from, to, round); }
  if (to === 'BHD') { return 'د.ب ' + printPricePretty(amount, from, to, round); }
  if (to === 'JOD') { return 'د.أ ' + printPricePretty(amount, from, to, round); }
  if (to === 'OMR') { return 'ر.ع ' + printPricePretty(amount, from, to, round); }
  if (to === 'INR') { return '₹' + printPricePretty(amount, from, to, round); }
  return printPricePretty(amount, from, to, round);
}

export function printPriceWithoutCurrencyName(amount, from, to, round = false) {

  if (to === 'USD') { return printPricePretty(amount, from, to, round); }
  if (to === 'GBP') { return printPricePretty(amount, from, to, round); }
  if (to === 'AED') { return printPricePretty(amount, from, to, round); }
  if (to === 'SAR') { return printPricePretty(amount, from, to, round); }
  if (to === 'QAR') { return printPricePretty(amount, from, to, round); }
  if (to === 'KWD') { return printPricePretty(amount, from, to, round); }
  if (to === 'BHD') { return printPricePretty(amount, from, to, round); }
  if (to === 'JOD') { return printPricePretty(amount, from, to, round); }
  if (to === 'OMR') { return printPricePretty(amount, from, to, round); }
  if (to === 'INR') { return printPricePretty(amount, from, to, round); }
  return printPricePretty(amount, from, to, round);
}

export function convert(amount, from, to) {

  if (currencyList.length === 0) {
    currencyList = getCurrencies();
    devLog(currencyList)
  }

  let amountUSD = amount;
  const fromCurrency = currencyList.find(x => x.name === from);
  const toCurrency = currencyList.find(x => x.name === to);

  // Convert to USD
  if (fromCurrency && fromCurrency.exchange_rate) {
    amountUSD = amount / fromCurrency.exchange_rate;
  }

  // Now from USD convert to other currencies
  if (toCurrency && toCurrency.exchange_rate) {
    amountUSD = amountUSD * toCurrency.exchange_rate;
  }

  return amountUSD;
}
//
// function roundToNearest(x) {
//   // const newX = Math.ceil(x / 5) * 5;
//   // return (newX > 0) ? newX : (newX < 0) ? 2 : x;
//   return x;
// }

export function printRequestLink(type, spaceType) {

  if (type === 'catered') {
    if (spaceType === 9) {

    } else if (spaceType === 9) {

    }
    return '';
  }

  if (type === 'lt') {
    if (spaceType === 9) {

    } else if (spaceType === 9) {

    }
    return '';
  }

  if (type === 'st') {
    if (spaceType === 9) {

    } else if (spaceType === 9) {

    }
    return '';
  }
  return '';
}

export function getCountryCode(country) {

  const countries = [["Afghanistan",["asia"],"af","93"],["Albania",["europe"],"al","355"],["Algeria",["africa","north-africa"],"dz","213"],["Andorra",["europe"],"ad","376"],["Angola",["africa"],"ao","244"],["Antigua and Barbuda",["america","carribean"],"ag","1268"],["Argentina",["america","south-america"],"ar","54","(..) ........",0,["11","221","223","261","264","2652","280","2905","291","2920","2966","299","341","342","343","351","376","379","381","3833","385","387","388"]],["Armenia",["asia","ex-ussr"],"am","374"],["Aruba",["america","carribean"],"aw","297"],["Australia",["oceania"],"au","61","(..) .... ....",0,["2","3","4","7","8","02","03","04","07","08"]],["Austria",["europe","eu-union"],"at","43"],["Azerbaijan",["asia","ex-ussr"],"az","994","(..) ... .. .."],["Bahamas",["america","carribean"],"bs","1242"],["Bahrain",["middle-east"],"bh","973"],["Bangladesh",["asia"],"bd","880"],["Barbados",["america","carribean"],"bb","1246"],["Belarus",["europe","ex-ussr"],"by","375","(..) ... .. .."],["Belgium",["europe","eu-union"],"be","32","... .. .. .."],["Belize",["america","central-america"],"bz","501"],["Benin",["africa"],"bj","229"],["Bhutan",["asia"],"bt","975"],["Bolivia",["america","south-america"],"bo","591"],["Bosnia and Herzegovina",["europe","ex-yugos"],"ba","387"],["Botswana",["africa"],"bw","267"],["Brazil",["america","south-america"],"br","55","(..) ........."],["British Indian Ocean Territory",["asia"],"io","246"],["Brunei",["asia"],"bn","673"],["Bulgaria",["europe","eu-union"],"bg","359"],["Burkina Faso",["africa"],"bf","226"],["Burundi",["africa"],"bi","257"],["Cambodia",["asia"],"kh","855"],["Cameroon",["africa"],"cm","237"],["Canada",["america","north-america"],"ca","1","(...) ...-....",1,["204","226","236","249","250","289","306","343","365","387","403","416","418","431","437","438","450","506","514","519","548","579","581","587","604","613","639","647","672","705","709","742","778","780","782","807","819","825","867","873","902","905"]],["Cape Verde",["africa"],"cv","238"],["Caribbean Netherlands",["america","carribean"],"bq","599","",1],["Central African Republic",["africa"],"cf","236"],["Chad",["africa"],"td","235"],["Chile",["america","south-america"],"cl","56"],["China",["asia"],"cn","86","..-........."],["Colombia",["america","south-america"],"co","57","... ... ...."],["Comoros",["africa"],"km","269"],["Congo",["africa"],"cd","243"],["Congo",["africa"],"cg","242"],["Costa Rica",["america","central-america"],"cr","506","....-...."],["Côte d’Ivoire",["africa"],"ci","225",".. .. .. .."],["Croatia",["europe","eu-union","ex-yugos"],"hr","385"],["Cuba",["america","carribean"],"cu","53"],["Curaçao",["america","carribean"],"cw","599","",0],["Cyprus",["europe","eu-union"],"cy","357",".. ......"],["Czech Republic",["europe","eu-union"],"cz","420"],["Denmark",["europe","eu-union","baltic"],"dk","45",".. .. .. .."],["Djibouti",["africa"],"dj","253"],["Dominica",["america","carribean"],"dm","1767"],["Dominican Republic",["america","carribean"],"do","1","",2,["809","829","849"]],["Ecuador",["america","south-america"],"ec","593"],["Egypt",["africa","north-africa"],"eg","20"],["El Salvador",["america","central-america"],"sv","503","....-...."],["Equatorial Guinea",["africa"],"gq","240"],["Eritrea",["africa"],"er","291"],["Estonia",["europe","eu-union","ex-ussr","baltic"],"ee","372",".... ......"],["Ethiopia",["africa"],"et","251"],["Fiji",["oceania"],"fj","679"],["Finland",["europe","eu-union","baltic"],"fi","358",".. ... .. .."],["France",["europe","eu-union"],"fr","33",". .. .. .. .."],["French Guiana",["america","south-america"],"gf","594"],["French Polynesia",["oceania"],"pf","689"],["Gabon",["africa"],"ga","241"],["Gambia",["africa"],"gm","220"],["Georgia",["asia","ex-ussr"],"ge","995"],["Germany",["europe","eu-union","baltic"],"de","49",".... ........"],["Ghana",["africa"],"gh","233"],["Greece",["europe","eu-union"],"gr","30"],["Grenada",["america","carribean"],"gd","1473"],["Guadeloupe",["america","carribean"],"gp","590","",0],["Guam",["oceania"],"gu","1671"],["Guatemala",["america","central-america"],"gt","502","....-...."],["Guinea",["africa"],"gn","224"],["Guinea-Bissau",["africa"],"gw","245"],["Guyana",["america","south-america"],"gy","592"],["Haiti",["america","carribean"],"ht","509","....-...."],["Honduras",["america","central-america"],"hn","504"],["Hong Kong",["asia"],"hk","852",".... ...."],["Hungary",["europe","eu-union"],"hu","36"],["Iceland",["europe"],"is","354","... ...."],["India",["asia"],"in","91",".....-....."],["Indonesia",["asia"],"id","62"],["Iran",["middle-east"],"ir","98","... ... ...."],["Iraq",["middle-east"],"iq","964"],["Ireland",["europe","eu-union"],"ie","353",".. ......."],["Israel",["middle-east"],"il","972","... ... ...."],["Italy",["europe","eu-union"],"it","39","... .......",0],["Jamaica",["america","carribean"],"jm","1876"],["Japan",["asia"],"jp","81",".. .... ...."],["Jordan",["middle-east"],"jo","962"],["Kazakhstan",["asia","ex-ussr"],"kz","7","... ...-..-..",1,["310","311","312","313","315","318","321","324","325","326","327","336","7172","73622"]],["Kenya",["africa"],"ke","254"],["Kiribati",["oceania"],"ki","686"],["Kosovo",["europe","ex-yugos"],"xk","383"],["Kuwait",["middle-east"],"kw","965"],["Kyrgyzstan",["asia","ex-ussr"],"kg","996"],["Laos",["asia"],"la","856"],["Latvia",["europe","eu-union","ex-ussr","baltic"],"lv","371"],["Lebanon",["middle-east"],"lb","961"],["Lesotho",["africa"],"ls","266"],["Liberia",["africa"],"lr","231"],["Libya",["africa","north-africa"],"ly","218"],["Liechtenstein",["europe"],"li","423"],["Lithuania",["europe","eu-union","ex-ussr","baltic"],"lt","370"],["Luxembourg",["europe","eu-union"],"lu","352"],["Macau",["asia"],"mo","853"],["Macedonia",["europe","ex-yugos"],"mk","389"],["Madagascar",["africa"],"mg","261"],["Malawi",["africa"],"mw","265"],["Malaysia",["asia"],"my","60","..-....-...."],["Maldives",["asia"],"mv","960"],["Mali",["africa"],"ml","223"],["Malta",["europe","eu-union"],"mt","356"],["Marshall Islands",["oceania"],"mh","692"],["Martinique",["america","carribean"],"mq","596"],["Mauritania",["africa"],"mr","222"],["Mauritius",["africa"],"mu","230"],["Mexico",["america","central-america"],"mx","52","... ... ....",0,["55","81","33","656","664","998","774","229"]],["Micronesia",["oceania"],"fm","691"],["Moldova",["europe"],"md","373","(..) ..-..-.."],["Monaco",["europe"],"mc","377"],["Mongolia",["asia"],"mn","976"],["Montenegro",["europe","ex-yugos"],"me","382"],["Morocco",["africa","north-africa"],"ma","212"],["Mozambique",["africa"],"mz","258"],["Myanmar",["asia"],"mm","95"],["Namibia",["africa"],"na","264"],["Nauru",["africa"],"nr","674"],["Nepal",["asia"],"np","977"],["Netherlands",["europe","eu-union"],"nl","31",".. ........"],["New Caledonia",["oceania"],"nc","687"],["New Zealand",["oceania"],"nz","64","...-...-...."],["Nicaragua",["america","central-america"],"ni","505"],["Niger",["africa"],"ne","227"],["Nigeria",["africa"],"ng","234"],["North Korea",["asia"],"kp","850"],["Norway",["europe","baltic"],"no","47","... .. ..."],["Oman",["middle-east"],"om","968"],["Pakistan",["asia"],"pk","92","...-......."],["Palau",["oceania"],"pw","680"],["Palestine",["middle-east"],"ps","970"],["Panama",["america","central-america"],"pa","507"],["Papua New Guinea",["oceania"],"pg","675"],["Paraguay",["america","south-america"],"py","595"],["Peru",["america","south-america"],"pe","51"],["Philippines",["asia"],"ph","63",".... ......."],["Poland",["europe","eu-union","baltic"],"pl","48","...-...-..."],["Portugal",["europe","eu-union"],"pt","351"],["Puerto Rico",["america","carribean"],"pr","1","",3,["787","939"]],["Qatar",["middle-east"],"qa","974"],["Réunion",["africa"],"re","262"],["Romania",["europe","eu-union"],"ro","40"],["Russia",["europe","asia","ex-ussr","baltic"],"ru","7","(...) ...-..-..",0],["Rwanda",["africa"],"rw","250"],["Saint Kitts and Nevis",["america","carribean"],"kn","1869"],["Saint Lucia",["america","carribean"],"lc","1758"],["Saint Vincent and the Grenadines",["america","carribean"],"vc","1784"],["Samoa",["oceania"],"ws","685"],["San Marino",["europe"],"sm","378"],["São Tomé and Príncipe",["africa"],"st","239"],["Saudi Arabia",["middle-east"],"sa","966"],["Senegal",["africa"],"sn","221"],["Serbia",["europe","ex-yugos"],"rs","381"],["Seychelles",["africa"],"sc","248"],["Sierra Leone",["africa"],"sl","232"],["Singapore",["asia"],"sg","65","....-...."],["Slovakia",["europe","eu-union"],"sk","421"],["Slovenia",["europe","eu-union","ex-yugos"],"si","386"],["Solomon Islands",["oceania"],"sb","677"],["Somalia",["africa"],"so","252"],["South Africa",["africa"],"za","27"],["South Korea",["asia"],"kr","82","... .... ...."],["South Sudan",["africa","north-africa"],"ss","211"],["Spain",["europe","eu-union"],"es","34","... ... ..."],["Sri Lanka",["asia"],"lk","94"],["Sudan",["africa"],"sd","249"],["Suriname",["america","south-america"],"sr","597"],["Swaziland",["africa"],"sz","268"],["Sweden",["europe","eu-union","baltic"],"se","46","(...) ...-..."],["Switzerland",["europe"],"ch","41",".. ... .. .."],["Syria",["middle-east"],"sy","963"],["Taiwan",["asia"],"tw","886"],["Tajikistan",["asia","ex-ussr"],"tj","992"],["Tanzania",["africa"],"tz","255"],["Thailand",["asia"],"th","66"],["Timor-Leste",["asia"],"tl","670"],["Togo",["africa"],"tg","228"],["Tonga",["oceania"],"to","676"],["Trinidad and Tobago",["america","carribean"],"tt","1868"],["Tunisia",["africa","north-africa"],"tn","216"],["Turkey",["europe"],"tr","90","... ... .. .."],["Turkmenistan",["asia","ex-ussr"],"tm","993"],["Tuvalu",["asia"],"tv","688"],["Uganda",["africa"],"ug","256"],["Ukraine",["europe","ex-ussr"],"ua","380","(..) ... .. .."],["United Arab Emirates",["middle-east"],"ae","971"],["United Kingdom",["europe","eu-union"],"gb","44",".... ......"],["United States",["america","north-america"],"us","1","(...) ...-....",0,["907","205","251","256","334","479","501","870","480","520","602","623","928","209","213","310","323","408","415","510","530","559","562","619","626","650","661","707","714","760","805","818","831","858","909","916","925","949","951","303","719","970","203","860","202","302","239","305","321","352","386","407","561","727","772","813","850","863","904","941","954","229","404","478","706","770","912","808","319","515","563","641","712","208","217","309","312","618","630","708","773","815","847","219","260","317","574","765","812","316","620","785","913","270","502","606","859","225","318","337","504","985","413","508","617","781","978","301","410","207","231","248","269","313","517","586","616","734","810","906","989","218","320","507","612","651","763","952","314","417","573","636","660","816","228","601","662","406","252","336","704","828","910","919","701","308","402","603","201","609","732","856","908","973","505","575","702","775","212","315","516","518","585","607","631","716","718","845","914","216","330","419","440","513","614","740","937","405","580","918","503","541","215","412","570","610","717","724","814","401","803","843","864","605","423","615","731","865","901","931","210","214","254","281","325","361","409","432","512","713","806","817","830","903","915","936","940","956","972","979","435","801","276","434","540","703","757","804","802","206","253","360","425","509","262","414","608","715","920","304","307"]],["Uruguay",["america","south-america"],"uy","598"],["Uzbekistan",["asia","ex-ussr"],"uz","998"],["Vanuatu",["oceania"],"vu","678"],["Vatican City",["europe"],"va","39",".. .... ....",1],["Venezuela",["america","south-america"],"ve","58"],["Vietnam",["asia"],"vn","84"],["Yemen",["middle-east"],"ye","967"],["Zambia",["africa"],"zm","260"],["Zimbabwe",["africa"],"zw","263"]], E=[["American Samoa",["oceania"],"as","1684"],["Anguilla",["america","carribean"],"ai","1264"],["Bermuda",["america","north-america"],"bm","1441"],["British Virgin Islands",["america","carribean"],"vg","1284"],["Cayman Islands",["america","carribean"],"ky","1345"],["Cook Islands",["oceania"],"ck","682"],["Falkland Islands",["america","south-america"],"fk","500"],["Faroe Islands",["europe"],"fo","298"],["Gibraltar",["europe"],"gi","350"],["Greenland",["america"],"gl","299"],["Jersey",["europe","eu-union"],"je","44",".... ......"],["Montserrat",["america","carribean"],"ms","1664"],["Niue",["asia"],"nu","683"],["Norfolk Island",["oceania"],"nf","672"],["Northern Mariana Islands",["oceania"],"mp","1670"],["Saint Barthélemy",["america","carribean"],"bl","590","",1],["Saint Helena",["africa"],"sh","290"],["Saint Martin",["america","carribean"],"mf","590","",2],["Saint Pierre and Miquelon",["america","north-america"],"pm","508"],["Sint Maarten",["america","carribean"],"sx","1721"],["Tokelau",["oceania"],"tk","690"],["Turks and Caicos Islands",["america","carribean"],"tc","1649"],["U.S. Virgin Islands",["america","carribean"],"vi","1340"],["Wallis and Futuna",["oceania"],"wf","681"]];
  
  const countryObj = countries.find(x => x[0] === country);
  return countryObj ? countryObj : ["United Arab Emirates",["middle-east"],"ae","971"];
}

export function getSpacePrice(space, service, term) {

  if (service === 'service') {
    if (space.starting_price > 0) return space.starting_price;
  }
  if (term === 'catered' || ((!space.hour_price || space.hour_price <= 0) && (!space.half_day_price || space.half_day_price <= 0) && (!space.day_price || space.day_price <= 0))) {
    if (space.catered_price > 0) return space.catered_price;
  }
  if (term === 'monthly' || ((!space.hour_price || space.hour_price <= 0) && (!space.half_day_price || space.half_day_price <= 0) && (!space.day_price || space.day_price <= 0))) {
    if (space.month_pass && space.month_price > 0) return space.month_price;
    if (space.quarter_pass && space.quarter_price > 0) return space.quarter_price;
    if (space.half_year_pass && space.half_year_price > 0) return space.half_year_price;
    if (space.year_pass && space.year_price > 0) return space.year_price;
  }
  if (space.hour_pass && space.hour_price > 0) return space.hour_price;
  if (space.half_day_pass && space.half_day_price > 0) return space.half_day_price;
  if (space.day_pass && space.day_price > 0) return space.day_price;


  return 0;
}

export function printSpacePricePer(space, service, term) {

  if (service === 'service') {
    if (space.starting_price > 0) return "";
  }
  if (term === 'catered' || ((!space.hour_price || space.hour_price <= 0) && (!space.half_day_price || space.half_day_price <= 0) && (!space.day_price || space.day_price <= 0))) {
    if (space.catered_price > 0) return " / person";
  }
  if (term === 'monthly' || ((!space.hour_price || space.hour_price <= 0) && (!space.half_day_price || space.half_day_price <= 0) && (!space.day_price || space.day_price <= 0))) {
    if (space.month_pass && space.month_price > 0) return " / month";
    if (space.quarter_pass && space.quarter_price > 0) return " / quarter";
    if (space.half_year_pass && space.half_year_price > 0) return " / half year";
    if (space.year_pass && space.year_price > 0) return " / year";
  }
  if (space.hour_pass && space.hour_price > 0) return " / hour";
  if (space.half_day_pass && space.half_day_price > 0) return " / half day";
  if (space.day_pass && space.day_price > 0) return " / day";

  return "";
}

export function getUser() {
  const userData = getStorage().getItem('user');
  return (userData && typeof userData !== 'undefined' && userData !== 'undefined') ? new User(JSON.parse(userData)) : null;
}
export function getUserData() {
  const userData = getStorage().getItem('user');
  return (userData && typeof userData !== 'undefined' && userData !== 'undefined') ? JSON.parse(userData) : null;
}

export function isHost() {
  return getUser()?.type === 'host'
}

export function getAskedLocation() {
  return getStorage().getItem('location');
}

export function getToken() {
  const token = getStorage().getItem('token');
  return (token && typeof token !== 'undefined' && token !== 'undefined') ? JSON.parse(token) : null;
}

export function getUserToken() {
  const userData =  getStorage().getItem('user');
  const token =  getStorage().getItem('token');
  return {
    user: (userData && typeof userData !== 'undefined' && userData !== 'undefined') ? new User(JSON.parse(userData)) : null,
    token:(token && typeof token !== 'undefined' && token !== 'undefined') ? JSON.parse(token) : null,
  };
}

export function getSpaceBooking() {
  return JSON.parse(getStorage().getItem('booking_space'));
}

export function getBooking() {
  return JSON.parse(getStorage().getItem('booking_proposal'));
}

export function getSource() {
  const source = getStorage().getItem('source');
  return (source) ? source : 'page';
}

export function getProposalBooking() {
  return JSON.parse(getStorage().getItem('booking_proposal'));
}

export function printHostBookingStatus(booking) {
  
  if (booking.status === 'completed') {
    return (<span style={{...ReservStyles.reservstatus, ...ReservStyles.statusgreen}}>Completed</span>);
  }
  if (booking.status === 'approved') {
    return (<span style={{...ReservStyles.reservstatus, ...ReservStyles.statusgreen}}>Paid &amp; Confirmed</span>);
  }
  if (booking.status === 'cancelled') {
    return (<span style={{...ReservStyles.reservstatus, ...ReservStyles.statusgray}}>Cancelled</span>);
  }
  if (booking.status === 'rejected' || booking.status === 'declined by venue' || booking.status === 'declined by fm') {
    return (<span style={{...ReservStyles.reservstatus, ...ReservStyles.statusred}}>Declined</span>);
  }
  if (booking.status === 'expired') {
    return (<span style={{...ReservStyles.reservstatus, ...ReservStyles.statusred}}>Expired</span>);
  }
  return (<span style={{...ReservStyles.reservstatus, ...ReservStyles.statusred}}>Pending</span>);
}

export function createAlert(ref, type, title, message, isTimeOut = true) {

  const id = Math.random();

  ref.setState({
    reqAlert: {
      id: id,
      type: type,
      title: title,
      message: message
    }
  });
  if (isTimeOut) {
    setTimeout(() => {
      const reqAlert = ref.state.reqAlert;
      if (reqAlert && reqAlert.id === id) {
        ref.setState({reqAlert: null});
      }
    }, 3000);
  }
}
export function createAlertFunctional(setReqAlert, type, title, message) {
  const id = Math.random();
  setReqAlert( {
      id: id,
      type: type,
      title: title,
      message: message
  });

  setTimeout(() => {
    setReqAlert(null);
  }, 3000);
}

export function createAlertFromMessage(ref, message) {
  createAlert(ref, message.type, message.title, message.message)
}

export function createAlertFromMessageFunctional(setReqAlert, message) {
  createAlertFunctional(setReqAlert, message.type, message.title, message.message)
}


export async function fetchField(field, key, value) {
  
  var params = {'field': field};
  if (key && value) {
    params[key] = value;
  }
  
  const url = getApiLinkV2("site/fields");
  return await getAxios().get(url, {
    headers: {'Content-Type': 'application/json'},
    params: params,
  }).then(response => {
    return response.data;
  }).catch(error => {
    devLog(error)
    Bugsnag.notify(error);
    return [];
  });
}


export function getLayoutImg(key) {
  
  switch (key) {
    case 'u_shape_chk':
      return ushape;
    case 'boardroom_chk':
      return boardroom;
    case 'reception_chk':
      return reception;
    case 'banquet_chk':
      return banquet;
    case 'theatre_chk':
      return theatre;
    case 'classroom_chk':
      return classroom;
    default:
      return ushape;
  }
}

export function getLayoutName(key) {

  switch (key) {
    case 'u_shape_chk':
      return 'U Shape'
    case 'boardroom_chk':
      return 'Boardroom';
    case 'reception_chk':
      return 'Reception';
    case 'banquet_chk':
      return 'Banquet';
    case 'theatre_chk':
      return 'Theatre';
    case 'classroom_chk':
      return 'Classroom';
    default:
      return 'U Shape';
  }
}

export function printSpaceData(type) {

  switch (type) {
    case '4':
    case 4:
      return { name: 'Co-working Spaces', food: '', term: 'monthly', service: 'space'};
    case '5':
    case 5:
      return { name: 'Meeting Rooms', food: 'catered', term: 'hourly', service: 'space'};
    case '9':
    case 9:
      return { name: 'Office spaces', food: '', term: 'monthly', service: 'space'};
    case '10':
    case 10:
      return { name: 'Banquet Halls & Event Spaces', food: 'catered', term: 'catered', service: 'space'};
    default:
      return { name: 'Business Setup', food: '', term: '', service: 'service'};
  }
}


export function getSpaceTerms(space) {

  const terms = [];

  switch (space.workspace_type_id) {
    case '10':
    case 10:
      if (hasTerm(space, 'catered')) terms.push('catered');
      if (hasTerm(space, 'hourly')) terms.push('hourly');
      break
    case '9':
    case '4':
    case 9:
    case 4:
      if (hasTerm(space, 'monthly')) terms.push('monthly');
      if (hasTerm(space, 'hourly')) terms.push('hourly');
      break;
    case '5':
    case 5:
      if (hasTerm(space, 'hourly')) terms.push('hourly');
      if (hasTerm(space, 'catered')) terms.push('catered');
      break;
    default:
      if (hasTerm(space, 'catered')) terms.push('catered');
      if (hasTerm(space, 'monthly')) terms.push('monthly');
      if (hasTerm(space, 'hourly')) terms.push('hourly');
      break;
  }

  return terms;
}

export function hasTerm(space, term) {

  switch (term) {
    case 'hourly':
      return (
          (space.hour_pass == 'yes' && space.hour_price > 0) ||
          (space.half_day_pass == 'yes' && space.half_day_price > 0) ||
          (space.day_pass == 'yes' && space.day_price > 0)
      );
    case 'monthly':
      return (
        (space.month_pass && space.month_price > 0) ||
        (space.quarter_pass && space.quarter_price > 0) ||
        (space.half_year_pass && space.half_year_price > 0) ||
        (space.year_pass && space.year_price > 0)
      );
    case 'catered':
      return (
        (space.one_coffee_break_pass && space.one_coffee_break_price > 0) ||
        (space.two_coffee_break_pass && space.two_coffee_break_price > 0) ||
        (space.lunch_dinner_pass && space.lunch_dinner_price > 0) ||
        (space.one_coffee_break_lunch_dinner_pass && space.one_coffee_break_lunch_dinner_price > 0) ||
        (space.two_coffee_break_lunch_dinner_pass && space.two_coffee_break_lunch_dinner_price > 0) ||
        
        (space.summer_one_coffee_break && space.summer_one_coffee_break > 0) ||
        (space.summer_two_coffee_break && space.summer_two_coffee_break > 0) ||
        (space.summer_one_coffee_break_lunch_dinner && space.summer_one_coffee_break_lunch_dinner > 0) ||
        (space.summer_two_coffee_breaks_lunch_dinner && space.summer_two_coffee_breaks_lunch_dinner > 0) ||
        (space.summer_lunch_dinner_non_alcoholic_drinks && space.summer_lunch_dinner_non_alcoholic_drinks > 0) ||
        (space.summer_lunch_dinner_alcoholic_drinks && space.summer_lunch_dinner_alcoholic_drinks > 0) ||
        (space.summer_minimum_price && space.summer_minimum_price > 0) ||

        (space.winter_one_coffee_break && space.winter_one_coffee_break > 0) ||
        (space.winter_two_coffee_break && space.winter_two_coffee_break > 0) ||
        (space.winter_one_coffee_break_lunch_dinner && space.winter_one_coffee_break_lunch_dinner > 0) ||
        (space.winter_two_coffee_breaks_lunch_dinner && space.winter_two_coffee_breaks_lunch_dinner > 0) ||
        (space.winter_lunch_dinner_non_alcoholic_drinks && space.winter_lunch_dinner_non_alcoholic_drinks > 0) ||
        (space.winter_lunch_dinner_alcoholic_drinks && space.winter_lunch_dinner_alcoholic_drinks > 0) ||
        (space.winter_minimum_price && space.winter_minimum_price > 0)
      );
    default:
      return false;
  }
}

export function doubleToPercentage(amount) {
  return (amount * 100).toFixed(2) + '%'
}

export function printAmenity(key) {
  
  switch (key) {
    case 'accommodation':
      return {name: 'Accommodation', image: accomdationIcon};
    case 'accessibility':
      return {name: 'Accessibility', image: accessibilityIcon};
    case 'bar':
      return {name: 'Bar', image: barIcon};
    case 'concierge':
      return { name: 'Concierge', image: conciergeIcon};
    case 'restaurant':
      return { name: 'Restaurant', image: resturantsIcon};
    case 'printer_scanner_fax':
      return { name: 'Printer/ Scanner/ Fax', image: printerIcon};
    case 'cafeteria':
      return { name: 'Cafeteria', image: coffeeIcon};
    case 'grocery':
      return { name: 'Grocery', image: groceryIcon};
    case 'gym':
      return { name: 'Gym', image: gymIcon};
    case 'parking':
      return { name: 'Parking', image: parkingIcon};
    case 'prayer_room':
      return { name: 'Prayer Room', image: prayerroomIcon};
    case 'reception':
      return { name: 'Reception', image: receptionIcon};
    case 'waste_disposal':
      return {name: 'Waste Disposal', image: wastedisposalIcon};
    case 'Wifi':
      return {name: 'Wifi', image: wifiIcon};
    case 'Projector & Screen':
      return {name: 'Projector & Screen', image: projectorIcon};
    case 'Flipchart':
      return {name: 'Flipchart', image: flipchartIcon};
    case 'Whiteboard':
      return {name: 'Whiteboard', image: whiteboardIcon};
    case "Notepads & Stationary":
      return {name: "Notepads & Stationary", image: statIcon};
    case "Lecturn":
      return {name: "Lecturn", image: lecturnIcon};
    case 'LCD Screen':
      return {name: 'LCD Screen', image: lcdIcon};
    case 'Mic':
      return {name: 'Mic', image: micIcon};
    case 'AV (Sound) System':
      return {name: 'AV (Sound) System', image: avIcon};
    case 'Video Conferencing':
      return {name: 'Video Conferencing', image: videoConfIcon};
    case 'Wifi (shared)':
      return {name: 'Wifi (shared)', image: wifiSharedIcon};
    case 'Furniture (private)':
      return { name: 'Furniture (private)', image: furniturePriIcon};
    case 'Telephone line (private)':
      return { name: 'Telephone line (private)', image: telPriIcon};
    case 'Electricity (shared)':
      return { name: 'Electricity (shared)', image: elecSharedIcon};
    case 'Receptionist(s) & Call Answering Services (shared)':
      return { name: 'Receptionist(s) & Call Answering Services (shared)', image: receptionIcon};
    case 'Mail Management':
      return { name: 'Mail Management', image: mailIcon};
    case 'Printer/Scanner/Fax (shared)':
      return { name: 'Printer/Scanner/Fax (shared)', image: printerIcon};
    case 'Pantry':
      return { name: 'Pantry', image: pantryIcon};
    case 'Pantry (Coffee, Tea, Water, Snacks) (shared)':
      return { name: 'Pantry (Coffee, Tea, Water, Snacks) (shared)', image: pantryIcon};
    default:
      return null;
  }
}

export function formValidation(key, value, req = true) {
  let _value = (typeof value === "string") ? value.trim() : value;
  switch (key) {
    case 'name':
      if (_value && _value !== '') {
        const re = /^[A-Za-z\s]+$/;
        return (re.test(String(_value).toLowerCase()) && _value.length < 40) ? null : 'Enter a valid name.';
      }
      return ((key === 'fname') ? 'First' : 'Last') + (' name is required.');
    case 'fname':
    case 'lname':
      if (_value && _value !== '') {
        const re = /^[A-Za-z\s]+$/;
        return (re.test(String(_value).toLowerCase()) && _value.length < 40) ? null : 'Enter a valid name.';
      }
      return ((key === 'fname') ? 'First' : 'Last') + (' name is required.');
    case 'email':
      if (_value && _value !== '') {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return (re.test(String(_value).toLowerCase())) ? null : 'Enter a valid email address.';
      }
      return 'Email address is required.';
    case 'confirmpass':
      if (_value && _value !== '') {
        return (_value.length < 6) ? 'Password should be more than 5 characters.' : null;
      }
      return 'Password confirmation is required.';
    case 'password':
      if (_value && _value !== '') {
        return (_value.length < 6) ? 'Password should be more than 5 characters.' : null;
      }
      return 'Password is required.';
    case 'phone':
      if (_value && _value !== '') {
        try {
          let phone = phoneUtil.parse(_value)
          return (phoneUtil.isValidNumber(phone)) ? null : 'Enter a valid phone number.';
        } catch (e) {
          return 'Enter a valid phone number.';
        }
        // const re = /^[0-9+]+$/;
        // return (re.test(String(_value).toLowerCase()) && _value.length < 20) ? null : 'Enter a valid phone number.';
  
      }
  
      return req ? 'Phone number is required.' : null;
    default:
      if (_value && _value !== '') return null;
      return req ? 'Field is required.' : null;
  }
}

export function updateCurrencyList() {

  const url = getApiLinkV2('settings/currency');
  getAxios().get(url, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(response => {
    if (response.data && response.data.length > 0) {
      const defCurr = response.data.find(x => x.name === 'USD');
      if (defCurr && defCurr.country)
        setCurrencies(response.data);
    }
  }).catch(error => {
    devLog(error);
  });
}

export function updateVatPercentages() {

  const url = getApiLinkV2('settings/vat');
  getAxios().get(url, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(response => {
    if (response.data && response.data.vat.length > 0) {
      setVatPercentage(response.data.vat);
    }
  }).catch(error => {
    devLog(error);
  });
}

export async function getUserCountry() {

  const url = "https://geolocation-db.com/jsonp/";
  return getAxios().get(url, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(response => {
    const data = JSON.parse(response.data.replace('callback(','').replace(')',''));
    return (data.country_name) ? data.country_name : null;
  }).catch(error => {
    devLog(error);
    return null;
  });
}

export function printDateForServer(date) {
  return ((date.getDate() < 9) ? "0"+date.getDate() : date.getDate()) + "-" + (((date.getMonth()+1) < 9) ? "0"+(date.getMonth()+1) : (date.getMonth()+1)) + "-" + (date.getFullYear());
}

export function printDateFromDateTime(date) {
  return moment(date, 'YYYY-MM-DD').format('MMM D, YYYY');
}

export function printDateTimeFromServer(datetime) {
  return moment(datetime).format('MMM D, YYYY h:mm:ss A');
}

export function sendEvent(category, action, label) {
  // const user = getUser();
  // const userId = user ? user.id : 0;
  ReactGA.event({ category, action: (category+' - '+action), label: (category+' - '+action+' - '+label) });
}

export function isDateExcluded(date) {

  const dates = [
    '10 Mar 2021',
    '11 Mar 2021',
    '12 May 2021',
    '13 May 2021',
    '14 May 2021',
    '15 May 2021',
    '18 Jul 2021',
    '19 Jul 2021',
    '20 Jul 2021',
    '21 Jul 2021',
    '22 Jul 2021',
    '09 Aug 2021',
    '10 Aug 2021',
    '18 Oct 2021',
    '19 Oct 2021',
    '30 Nov 2021',
    '1 Dec 2021',
    '2 Dec 2021',
  ];

  return (dates[date.getDay()] == null)
}

export function printBookingStatus(req) {

  if (req.status === 'completed') {
    return (<div className="reserv-status reserv-status-green">Completed</div>);
  }
  if (req.status === 'approved') {
    return (<div className="reserv-status reserv-status-green">Approved</div>);
  }
  if (req.status === 'cancelled') {
    return (<div className="reserv-status reserv-status-gray">Cancelled</div>);
  }
  if (req.status === 'pending') {
    if (req.reservation_status === 'rejected') return (<div className="reserv-status reserv-status-red">Rejected</div>);
    return (<div className="reserv-status reserv-status-black">Pending</div>);
  }
  return (<></>);
}

export function printTimeRange(startDate, endDate, addDate = false) {

  if (addDate) {
    return moment("2021-01-01 " + startDate).format('h:mm:ss a')+" to "+moment("2021-01-01 " + endDate).format('h:mm:ss a');
  }
  return moment(startDate).format('h:mm A')+" to "+moment(endDate).format('h:mm A');
}

export function nth(d) {
  const day = parseInt(d);
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:  return "st";
    case 2:  return "nd";
    case 3:  return "rd";
    default: return "th";
  }
}

export function getDayName(date) {

  var day = '';
  const dayIndex = date.getDay();
  if (dayIndex === 0) { day = 'Sunday'; }
  else if (dayIndex === 1) { day = 'Monday'; }
  else if (dayIndex === 2) { day = 'Tuesday'; }
  else if (dayIndex === 3) { day = 'Wednesday'; }
  else if (dayIndex === 4) { day = 'Thursday'; }
  else if (dayIndex === 5) { day = 'Friday'; }
  else if (dayIndex === 6) { day = 'Saturday'; }
  return day;
}

export function bookingStatus(status) {

  switch (status) {
    case '1':
      return 'Called - no response';
    case '2':
      return 'Called – client requested more info';
    case '3':
      return 'Called – client visit arranged';
    case '4':
      return 'Called – client needs time to decide';
    case '5':
      return 'Called – client not interested';
    case '6':
      return 'Called – client interested in booking';
    case '7':
      return 'Client visited - awaiting feedback';
    case '8':
      return 'Client visited – Interested in booking';
    case '9':
      return 'Client visited - Not interested';
    case '10':
      return 'Booked with another venue';
    case '11':
      return 'Client booked with us';
    default:
      return '';
  }
}

export function daysInMonth(date) {

  var day = '';
  const dayIndex = date.getDay();
  if (dayIndex === 0) { day = 'sunday'; }
  else if (dayIndex === 1) { day = 'monday'; }
  else if (dayIndex === 2) { day = 'tuesday'; }
  else if (dayIndex === 3) { day = 'wednesday'; }
  else if (dayIndex === 4) { day = 'thursday'; }
  else if (dayIndex === 5) { day = 'friday'; }
  else if (dayIndex === 6) { day = 'saturday'; }

  const firstDayMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  var firstDate = 1;
  var dayRank = 1;
  for (var i = firstDayMonth.getDay(); i < firstDayMonth.getDay()+7; i++) {
    const fIdx = (i < 7) ? i : i-7;
    if (fIdx === date.getDay()) {
      break;
    }
    firstDate++;
  }
  for (var x = firstDate; x <= 31; x += 7) {
    if (x === date.getDate()) {
      return dayRank+nth(dayRank)+' '+day;
    }
    dayRank++;
  }
  return 0;
}

export function addDays(date, daysNum) {
  const nextDate = new Date(date);
  nextDate.setDate(date.getDate() + daysNum);
  return nextDate;
}

export function checkAvailableTimeFromBooking(date, time, bookings, minHoursDiff)
{
  let flag = true;
  let d = new Date(date);
  let dStr = (d.getFullYear() + '-' + ((d.getMonth() + 1) < 10 ? '0'+(d.getMonth() + 1) : d.getMonth()) + '-' + (d.getDate() < 10 ? '0'+d.getDate() : d.getDate())) + ' ' + time;
  let nd = Date.parse(new Date(dStr));

  for (let index = 0; index < bookings.length; index++) {
    const booking = bookings[index];
    let sd = new Date(booking.start);
    sd.setHours(sd.getHours() - parseInt(minHoursDiff));
    let start = Date.parse(sd);
    let end = Date.parse(new Date(booking.end));
    if (nd < end && nd >= start) {
      flag = false;
    }
    
  }
  return flag;
}

export function checkAvailableEndTimeFromBooking(date, startTime, endTime, bookings)
{
  let d = new Date(date);
  let dStr = (d.getFullYear() + '-' + ((d.getMonth() + 1) < 10 ? '0'+(d.getMonth() + 1) : d.getMonth()) + '-' + (d.getDate() < 10 ? '0'+d.getDate() : d.getDate())) + ' ' + endTime;
  let nd = Date.parse(new Date(dStr));

  let dsStr = (d.getFullYear() + '-' + ((d.getMonth() + 1) < 10 ? '0'+(d.getMonth() + 1) : d.getMonth()) + '-' + (d.getDate() < 10 ? '0'+d.getDate() : d.getDate())) + ' ' + startTime;
  let sd = Date.parse(new Date(dsStr));

  let flag = true;

  for (let index = 0; index < bookings.length; index++) {
    const booking = bookings[index];
    let start = Date.parse(new Date(booking.start));
    if (nd > start && sd <= start) {
      flag = false;
    }
  }

  return flag;
}

export function updateStartTime(ws_avail, day, isCalendarEnabled = false, bookings = [], startDate = '', minHoursDiff = 1) {

  var output = [];

  if (ws_avail && ws_avail[day]) {

    var dayTime = ws_avail[day];

    if (dayTime === "closed") {
      return(<></>);
    }

    var start_hr = (dayTime === "open_24_hours") ? 0 : parseInt(dayTime.substr(0, 2));
    var start_min = (dayTime === "open_24_hours") ? 0 : parseInt(dayTime.substr(3, 2));
    var end_hr = (dayTime === "open_24_hours") ? 24 : parseInt(dayTime.substr(9, 2));
    var end_min = (dayTime === "open_24_hours") ? 0 : parseInt(dayTime.substr(12, 2));
    var tf = 'AM';
    var df = 0;

    for (var i = start_hr; i <= end_hr-parseInt(minHoursDiff); i++) {
      if (i === start_hr) {
        if (i < 13) { tf = 'AM'; df = i; } else { tf = 'PM'; df = i - 12; }
        if (i === 0) { df = '12'; }
        if (i === 12) { tf = 'PM'; } else if (i === 24) { tf = 'AM'; }
        for (var j = start_min; j <= 45; j = j+30) {
          if (isCalendarEnabled) {
            if (checkAvailableTimeFromBooking(startDate, ("0" + i).slice(-2) +':'+ ("0" + j).slice(-2) +":00", bookings, minHoursDiff)) {
              output.push(
                <option value={("0" + i).slice(-2) +':'+ ("0" + j).slice(-2) +":00"}>
                  {("0" + df).slice(-2) +':'+ ("0" + j).slice(-2) +' '+ tf}
                </option>);
            } else {
              output.push(
                <option value={("0" + i).slice(-2) +':'+ ("0" + j).slice(-2) +":00"} disabled>
                  {("0" + df).slice(-2) +':'+ ("0" + j).slice(-2) +' '+ tf}
                </option>);
            }
          } else {
            output.push(
              <option value={("0" + i).slice(-2) +':'+ ("0" + j).slice(-2) +":00"}>
                {("0" + df).slice(-2) +':'+ ("0" + j).slice(-2) +' '+ tf}
              </option>);
          }
        }
      } else {
        if (i === end_hr-parseInt(minHoursDiff) && end_min === 0) {
          if (i < 13) { tf = 'AM'; df = i; } else { tf = 'PM'; df = i - 12; }
          if (i === 0) { df = '12'; }
          if (i === 12) { tf = 'PM'; } else if (i === 24) { tf = 'AM'; }
          if (isCalendarEnabled) {
            if (checkAvailableTimeFromBooking(startDate, ("0" + i).slice(-2) +":00:00", bookings, minHoursDiff)) {
              output.push(
                <option value={("0" + i).slice(-2) +":00:00"}>
                  {("0" + df).slice(-2) +':00 '+ tf}
                </option>);
            } else {
              output.push(
                <option value={("0" + i).slice(-2) +":00:00"} disabled>
                  {("0" + df).slice(-2) +':00 '+ tf}
                </option>);
            }
          } else {
            output.push(
              <option value={("0" + i).slice(-2) +":00:00"}>
                {("0" + df).slice(-2) +':00 '+ tf}
              </option>);
          }
        } else {
          if (i < 13) { tf = 'AM'; df = i; } else { tf = 'PM'; df = i - 12; }
          if (i === 0) { df = '12'; }
          if (i === 12) { tf = 'PM'; } else if (i === 24) { tf = 'AM'; }
          for (var j = 0; j <= 45; j = j+30) {
            if (isCalendarEnabled) {
              if (checkAvailableTimeFromBooking(startDate, ("0" + i).slice(-2) + ':' + ("0" + j).slice(-2) + ":00", bookings, minHoursDiff)) {
                output.push(
                  <option value={("0" + i).slice(-2) + ':' + ("0" + j).slice(-2) + ":00"}>
                    {("0" + df).slice(-2) + ':' + ("0" + j).slice(-2) + ' ' + tf}
                  </option>);
              } else {
                output.push(
                  <option value={("0" + i).slice(-2) + ':' + ("0" + j).slice(-2) + ":00"} disabled>
                    {("0" + df).slice(-2) + ':' + ("0" + j).slice(-2) + ' ' + tf}
                  </option>);
              }
            } else {
              output.push(
                <option value={("0" + i).slice(-2) + ':' + ("0" + j).slice(-2) + ":00"}>
                  {("0" + df).slice(-2) + ':' + ("0" + j).slice(-2) + ' ' + tf}
                </option>);
            }
          }
        }
      }
    }
    return output;

  } else {

    var tf = 'AM';
    var df = 0;
    for (var i = 7; i <= 22; i++) {
      if (i < 13) { tf = 'AM'; df = i; } else { tf = 'PM'; df = i - 12; }
      if (i === 0) { df = '12'; }
      if (i === 12) { tf = 'PM'; } else if (i === 24) { tf = 'AM'; }
      for (var j = 0; j <= 45; j = j+30) {
        if (isCalendarEnabled) {
          if (checkAvailableTimeFromBooking(startDate, ("0" + i).slice(-2) + ':' + ("0" + j).slice(-2) + ":00", bookings, minHoursDiff)) {
            output.push(
              <option value={("0" + i).slice(-2) + ':' + ("0" + j).slice(-2) + ":00"}>
                {("0" + df).slice(-2) + ':' + ("0" + j).slice(-2) + ' ' + tf}
              </option>);
          } else {
            output.push(
              <option value={("0" + i).slice(-2) + ':' + ("0" + j).slice(-2) + ":00"} disabled>
                {("0" + df).slice(-2) + ':' + ("0" + j).slice(-2) + ' ' + tf}
              </option>);
          }
        } else {
          output.push(
            <option value={("0" + i).slice(-2) + ':' + ("0" + j).slice(-2) + ":00"}>
              {("0" + df).slice(-2) + ':' + ("0" + j).slice(-2) + ' ' + tf}
            </option>);
        }
      }
    }
    return output;
  }
}

export function updateEndTime(ws_avail, day, start_time, minHoursDiff, isCalendarEnabled = false, bookings = [], startDate = '') {

  var output = [];

  if (ws_avail && ws_avail[day]) {

    var dayTime = ws_avail[day];

    if (dayTime === "closed") {
      return(<></>);
    }

    var start_hr = (start_time) ? parseInt(start_time.substr(0, 2)) : ((dayTime === "open_24_hours") ? 0 : (parseInt(dayTime.substr(0, 2))));
    var start_min = (start_time) ? parseInt(start_time.substr(3, 2)) : ((dayTime === "open_24_hours") ? 0 : parseInt(dayTime.substr(3, 2)));
    var end_hr = (dayTime === "open_24_hours") ? 23 : parseInt(dayTime.substr(9, 2));
    var end_min = (dayTime === "open_24_hours") ? 0 : parseInt(dayTime.substr(12, 2));
    var tf = 'AM';
    var df = 0;
    end_hr = (dayTime === "open_24_hours") ? end_hr : ((start_min > 0 && end_min === 0) ? end_hr-1 : end_hr);

    if (dayTime === "open_24_hours" && start_hr === 23) {
      end_hr = 24
    }

    for (var i = start_hr+minHoursDiff; i <= end_hr; i++) {

      if (i < 13) { tf = 'AM'; df = i; } else { tf = 'PM'; df = i - 12; }
      if (i === 0) { df = '12'; }
      if (i === 12) { tf = 'PM'; } else if (i === 24) { tf = 'AM'; }
      if (isCalendarEnabled) {
        if (checkAvailableEndTimeFromBooking(startDate, start_time, ("0" + i).slice(-2) +':'+ ("0" + start_min).slice(-2) +":00", bookings)) {
          output.push(
            <option value={("0" + i).slice(-2) +':'+ ("0" + start_min).slice(-2) +":00"}>
              {("0" + df).slice(-2) +':'+ ("0" + start_min).slice(-2) +' '+ tf}
            </option>);
          } else {
            output.push(
              <option value={("0" + i).slice(-2) +':'+ ("0" + start_min).slice(-2) +":00"} disabled>
                {("0" + df).slice(-2) +':'+ ("0" + start_min).slice(-2) +' '+ tf}
              </option>);
          }
        } else {
          output.push(
            <option value={("0" + i).slice(-2) +':'+ ("0" + start_min).slice(-2) +":00"}>
              {("0" + df).slice(-2) +':'+ ("0" + start_min).slice(-2) +' '+ tf}
            </option>);
        }
    }
    return output;

  } else {

    var start_hr = (start_time) ? parseInt(start_time.substr(0, 2)) : 7;
    var start_min = (start_time) ? parseInt(start_time.substr(3, 2)) : 0;
    var end_hr =  (start_min > 0) ? 22 : 23;

    var tf = 'AM';
    var df = 0;
    for (var i = start_hr; i <= end_hr; i++) {
      if (i < 13) { tf = 'AM'; df = i; } else { tf = 'PM'; df = i - 12; }
      if (i === 0) { df = '12'; }
      if (i === 12) { tf = 'PM'; }
      if (i === 24) { tf = 'AM'; }
      if (isCalendarEnabled) {
        if (checkAvailableEndTimeFromBooking(startDate, start_time, ("0" + i).slice(-2) +':'+ ("0" + start_min).slice(-2) +":00", bookings)) {
          output.push(
            <option value={("0" + i).slice(-2) +':'+ ("0" + start_min).slice(-2) +":00"}>
              {("0" + df).slice(-2) +':'+ ("0" + start_min).slice(-2) +' '+ tf}
            </option>);
          } else {
            output.push(
              <option value={("0" + i).slice(-2) +':'+ ("0" + start_min).slice(-2) +":00"} disabled>
                {("0" + df).slice(-2) +':'+ ("0" + start_min).slice(-2) +' '+ tf}
              </option>);
          }
        } else {
          output.push(
            <option value={("0" + i).slice(-2) +':'+ ("0" + start_min).slice(-2) +":00"}>
              {("0" + df).slice(-2) +':'+ ("0" + start_min).slice(-2) +' '+ tf}
            </option>);
        }
      
    }
    return output;
  }
}


export function updateHalfDayTime(ws_avail, day) {

  var output = [];

  if (ws_avail && ws_avail[day]) {

    var dayTime = ws_avail[day];

    if (dayTime === "closed") return (<></>);

    var start_hr = (dayTime === "open_24_hours") ? 9 : parseInt(dayTime.substr(0, 2));
    var start_min = (dayTime === "open_24_hours") ? 0 : parseInt(dayTime.substr(3, 2));
    var end_hr = (dayTime === "open_24_hours") ? 18 : parseInt(dayTime.substr(9, 2));
    var end_min = (dayTime === "open_24_hours") ? 0 : parseInt(dayTime.substr(12, 2));
    var tf = 'AM';
    var df = 0;
    var tfe = 'AM';
    var dfe = 0;

    for (var i = start_hr; i <= end_hr-4; i = i+5) {

      var n = i+4;

      if (i < 13) { tf = 'AM'; df = i; } else { tf = 'PM'; df = i - 12; }
      if (i === 0) { df = '12'; }
      if (i === 12) { tf = 'PM'; } else if (i === 24) { tf = 'AM'; }

      if (n < 13) { tfe = 'AM'; dfe = n; } else { tfe = 'PM'; dfe = n - 12; }
      if (n === 0) { dfe = '12'; }
      if (n === 12) { tfe = 'PM'; } else if (n === 24) { tfe = 'AM'; }

      output.push(
        <option value={("0" + i).slice(-2) +':'+ ("0" + start_min).slice(-2) +':00-'+ ("0" + n).slice(-2) +':'+ ("0" + start_min).slice(-2) +":00"}>
          {("0" + df).slice(-2) +':'+ ("0" + start_min).slice(-2) +' '+ tf +' to '+ ("0" + dfe).slice(-2) +':'+ ("0" + start_min).slice(-2) +' '+ tfe}
        </option>);

    }

    if (output.length === 0) {
      output.push(
        <option value={("0" + start_hr).slice(-2) +':'+ ("0" + start_min).slice(-2) +':00-'+ ("0" + end_hr).slice(-2) +':'+ ("0" + end_min).slice(-2) +":00"}>
        {("0" + start_hr).slice(-2) +':'+ ("0" + start_min).slice(-2) +' '+ ((start_hr < 13) ? 'AM' : 'PM') +' to '+ ("0" + end_hr).slice(-2) +':'+ ("0" + end_min).slice(-2) +' '+ ((end_hr < 13) ? 'AM' : 'PM')}
      </option>);
    }

    return output;

  } else {

    output.push('<option value="09:00:00-13:00:00">09:00 AM To 01:00 PM</option>');
    return output;
  }
}

export function updateFullDayTime(ws_avail, day) {

  var output = [];

  if (ws_avail && ws_avail[day]) {

    var dayTime = ws_avail[day];

    if (dayTime === "closed") return (<></>);


    var start_hr = (dayTime === "open_24_hours") ? 9 : parseInt(dayTime.substr(0, 2));
    var start_min = (dayTime === "open_24_hours") ? 0 : parseInt(dayTime.substr(3, 2));
    var end_hr = (dayTime === "open_24_hours") ? 18 : parseInt(dayTime.substr(9, 2));
    var end_min = (dayTime === "open_24_hours") ? 0 : parseInt(dayTime.substr(12, 2));
    var tf = 'AM';
    var df = 0;
    var tfe = 'AM';
    var dfe = 0;
    console.log(start_hr, end_hr);
    if (start_hr < 13) { tf = 'AM'; df = start_hr; } else { tf = 'PM'; df = start_hr - 12; }
    if (start_hr === 0) { df = '24'; }
    if (start_hr === 12) { tf = 'PM'; }

    if (end_hr < 13) { tfe = 'AM'; dfe = end_hr; } else { tfe = 'PM'; dfe = end_hr - 12; }
    if (end_hr === 0) { dfe = '12'; }
    if (end_hr === 12) { tfe = 'PM'; } else if (end_hr === 24) { tfe = 'AM'; }

    output.push(
      <option value={("0" + start_hr).slice(-2) +':'+ ("0" + start_min).slice(-2) +':00-'+ ("0" + end_hr).slice(-2) +':'+ ("0" + end_min).slice(-2) +":00"}>
        {("0" + df).slice(-2) +':'+ ("0" + start_min).slice(-2) +' '+ tf +' to '+ ("0" + dfe).slice(-2) +':'+ ("0" + end_min).slice(-2) +' '+ tfe}
      </option>);

    return output;

  } else {

    output.push('<option value="09:00:00-13:00:00">09:00 AM To 01:00 PM</option>');
    return output;
  }
  
}


export function printRule(rule) {

  switch (rule) {
    case 'No-Smoking':
      return 'Smoking are not allowed';
    case 'No-Alcohol':
      return 'Alcohol are not allowed';
    case 'No-Children':
      return 'Children are not allowed';
    case 'No-Pets':
      return 'Pets are not allowed';
    case 'Keep-Noise-Down':
      return 'Keep noise down';
  }
}

export function utf8_to_b64(str) {
  return encodeURIComponent(Buffer.from(str, 'utf8').toString('base64'));
}

export function b64_to_utf8(str) {
  return decodeURIComponent(Buffer.from(str, 'base64').toString('utf8'));
}

export function decodeQuery(query: URLSearchParams, key: String) {
  let param = query.get(key)
  if (param) return b64_to_utf8(param)
  else return null
  
}

export function E164FormatNumber(number: String | undefined) {
  if (number) {
    try {
      let phone = phoneUtil.parse(number)
      return phoneUtil.format(phone, PNF.E164)
    } catch (e) {
      throw "Invalid Phone Number";
    }
  } else {
    throw "Invalid Phone Number";
  }
  
  
}

